import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Psitron Technologies | MLOps Training Program | Enroll Now',
      // Free-demo Google Ads landing page: keep out of organic search so it
      // does not cannibalize the paid-course page (mlops.psitrontech.com).
      robots: 'noindex, follow'
    }
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    // Lazy-load ThankYou page - only downloaded when user navigates to it
    component: () => import('../views/ThankYou.vue'),
    meta: {
      title: 'Registration Confirmed | Psitron Technologies',
      // Confirmation page must never be indexed by search engines
      robots: 'noindex, nofollow'
    }
  },
  {
    // Any unknown path redirects to home instead of showing a blank SPA shell
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  // HTML5 history mode removes the "#" from URLs (e.g. /thankyou instead of /#/thankyou).
  // Requires the host to rewrite deep links to /index.html (Amplify SPA rewrite rule).
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // Always land at the top of the page on navigation
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// Keep the document title and robots directive in sync with the active route.
// Runs in the browser and during prerendering, so each generated HTML file gets
// its own <title> and the correct index / noindex signal.
router.afterEach((to) => {
  const meta = to.meta || {}
  if (meta.title) {
    document.title = meta.title
  }
  if (meta.robots) {
    let robotsTag = document.querySelector('meta[name="robots"]')
    if (!robotsTag) {
      robotsTag = document.createElement('meta')
      robotsTag.setAttribute('name', 'robots')
      document.head.appendChild(robotsTag)
    }
    robotsTag.setAttribute('content', meta.robots)
  }
})

export default router
